import { createPasswordRule, createPasswordValidation, FormContextValues, Validate } from '@dreryk/react-common';
import { PasswordInput } from '@dreryk/react-components';

import { nfzLoginTranslationKeys } from '../../../../translations';

const NEW_PASSWORD_FIELD_NAME = 'newPassword';
const NEW_PASSWORD_MIN_LENGTH = 8;
const NEW_PASSWORD_MAX_LENGTH = 50;

const ewusPasswordValidation = createPasswordValidation(
   createPasswordRule.length(NEW_PASSWORD_MIN_LENGTH),
   createPasswordRule.smallLetter(),
   createPasswordRule.bigLetter(),
   createPasswordRule.number(),
   createPasswordRule.specialCharacter()
);

const validate: Validate = (data, getValue) => {
   const oldPassword = getValue('password');
   if (oldPassword === data) {
      return nfzLoginTranslationKeys.passwordIsNotDifferent;
   }

   if (!ewusPasswordValidation(data as string)) {
      return nfzLoginTranslationKeys.passwordNotMatchingRestrictions;
   }

   return undefined;
};

export type NewPasswordFormBeanPart = { [NEW_PASSWORD_FIELD_NAME]: string | null };

type NewPasswordFieldProps = Pick<FormContextValues<NewPasswordFormBeanPart>, 'register'>;

export const NewPasswordField = (props: NewPasswordFieldProps): JSX.Element => {
   const controller = props.register(NEW_PASSWORD_FIELD_NAME, {
      required: true,
      maxLength: NEW_PASSWORD_MAX_LENGTH,
      validate: validate,
   });

   return <PasswordInput label={nfzLoginTranslationKeys.newPassword} controller={controller} testId={'newPassword'} />;
};
